module.exports = __webpack_public_path__ + "static/media/Sissi.885a2aa0.jpg";